import {parse as parseCookies} from "cookie";

export const getCookie = (cookie) => {
  // eslint-disable-next-line
  if (globalThis?.document?.cookie) {
    // eslint-disable-next-line
    return parseCookies(globalThis.document.cookie)?.[cookie];
  }

  return;
}

export const setCookie = (cookie, val, age = 365) => { // age в днях
  // eslint-disable-next-line
  globalThis.document.cookie = `${cookie}=${val};path=/;max-age=${age*24*60*60};`;
}

export const removeCookie = (cookie) => {
  // eslint-disable-next-line
  globalThis.document.cookie = `${cookie}=; max-age=0;`;
}